import * as React from "react"

export default function MeetupIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.4141 6L15.707 10.707L14.293 9.29297L16.5859 7H7C4.79086 7 3 8.79086 3 11C3 13.2091 4.79087 15 7 15H25C28.3137 15 31 17.6863 31 21C31 24.3137 28.3137 27 25 27H9.87402C9.42998 28.7252 7.86384 30 6 30C3.79086 30 2 28.2091 2 26C2 23.7909 3.79086 22 6 22C7.86384 22 9.42998 23.2748 9.87402 25H25C27.2091 25 29 23.2091 29 21C29 18.7909 27.2091 17 25 17H7C3.68629 17 1 14.3137 1 11C1 7.6863 3.6863 5 7 5H16.5859L14.293 2.70703L15.707 1.29297L20.4141 6ZM6 24C4.89543 24 4 24.8954 4 26C4 27.1046 4.89543 28 6 28C7.10457 28 8 27.1046 8 26C8 24.8954 7.10457 24 6 24ZM26 2C28.2091 2 30 3.79086 30 6C30 8.20914 28.2091 10 26 10C23.7909 10 22 8.20914 22 6C22 3.79086 23.7909 2 26 2ZM26 4C24.8954 4 24 4.89543 24 6C24 7.10457 24.8954 8 26 8C27.1046 8 28 7.10457 28 6C28 4.89543 27.1046 4 26 4Z"
        fill={props.fill}
      />
    </svg>
  )
}